const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-bars', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			init: {
				type: Object,
				required: true
			},
			chartData: {
				type: Object,
				required: true
			},
			chartRequest: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nnchartbars-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			Vue.nextTick(() => {
				this.setupChart();
			});
		},
		methods: {
			setupChart: function () {
				var colors = window.getChartColors(this.chartData.Values.length);
				const drilldown = this.chartData.Drilldown;

				var data = Array.prototype.map.call(this.chartData.Values, (el, i) => {
					let dimension = el.Dimension1;
					return {
						no: i + 1,
						name: dimension,
						y: el.Fact1 || el.Number,
						color: colors[i]
					}
				});
				const maxAvg = this.getMaxAverage(data);

				const plotlines = this.getPlotLines(this.chartRequest.plotLines, maxAvg);

				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						type: 'bar'
					},
					plotOptions: {
						bar: {
							dataLabels: {
								enabled: true,
								color: globalColors.primary.hue9
							},
							borderWidth: 0
						}
					},
					xAxis: {
						type: 'category',
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 0
					},
					yAxis: {
						max: maxAvg.max,
						title: {
							text: this.chartData.Kpi[0].KPIName,
							style: {
								color: globalColors.primary.hue9
							}
						},
						labels: {
							formatter: function () {
								return this.value;
							},
							style: {
								color: globalColors.primary.hue9
							}
						},
						tickColor: globalColors.primary.hue1,
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 1,
						showFirstLabel: false,
						showLastLabel: false,
						plotLines: window.cloneObject(plotlines)
					},
					series: [
						{
							data: data,
							dataLabels: {}
						}
					]
				}));
				this.$emit('chartReady', this.chart);
			}
		}
	})
})();

